/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1Course200,
  GetApiV1Course400,
  GetApiV1Course401,
  GetApiV1Course500,
  GetApiV1CourseQueryParams,
  GetApiV1CourseQueryResponse,
} from "../../types/courseRegistrationController/GetApiV1Course.ts";
import { courseListItemViewModelPaginatedResponseSchema } from "../courseListItemViewModelPaginatedResponseSchema.ts";
import { eCompanyFilterTypeSchema } from "../eCompanyFilterTypeSchema.ts";

export const getApiV1CourseQueryParamsSchema = z.object({
  Filter: z.optional(
    z
      .lazy(() => eCompanyFilterTypeSchema)
      .describe("1 = Main | 2 = Company | 3 = All | "),
  ),
  CompanyId: z.optional(
    z.coerce
      .number()
      .int()
      .describe(
        "ID da empresa usada no escopo Company. Ignorado quando o usuário autenticado é vinculado a uma empresa. Opcional.",
      ),
  ),
  Search: z.optional(
    z
      .string()
      .describe(
        "Texto livre aplicado ao código e ao nome oficial do curso. Máximo de 200 caracteres. Opcional.",
      ),
  ),
  Active: z
    .boolean()
    .default(true)
    .describe(
      "Define se a listagem traz apenas cursos ativos. Informe null para trazer ativos e inativos. Opcional.",
    ),
  PageNumber: z.coerce
    .number()
    .int()
    .default(1)
    .describe("Página da listagem. Mínimo 1."),
  PageSize: z.coerce
    .number()
    .int()
    .default(30)
    .describe("Quantidade de itens por página. Entre 1 e 100."),
}) as unknown as ToZod<GetApiV1CourseQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1Course200Schema = z.lazy(
  () => courseListItemViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1Course200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1Course400Schema =
  z.any() as unknown as ToZod<GetApiV1Course400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1Course401Schema =
  z.any() as unknown as ToZod<GetApiV1Course401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1Course500Schema =
  z.any() as unknown as ToZod<GetApiV1Course500>;

export const getApiV1CourseQueryResponseSchema = z.lazy(
  () => getApiV1Course200Schema,
) as unknown as ToZod<GetApiV1CourseQueryResponse>;
